import React from 'react';
import genStyles from '../generale.module.css';
import DrawService from '../../service/DrawService';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { 
    activeformEditEntiteState, 
    activeformNewEntiteState, 
    apiCollectionState, 
    boolModifState, 
    collectionsCurState, 
    collectionsModeleState, 
    currentPageModeleAtom, 
    idLayerEditState, 
    loadingState, 
    localDataState, 
    markerFormEditState, 
    modeleLayerCurState, 
    searchQueryModeleAtom, 
    sortConfigModeleAtom, 
    toastState, 
    typeCollectionState, 
    typeformEditEntiteState, 
    userDataState 
} from '../../atoms/CollectionState';
import CollectionService from '../../service/CollectionService';
import ResultForm from '../resultat/resultatForm';
import ShowService from '../../service/showService';

export default function EntityNewForm({setEntiteslist,setOpenStates,modeleCollection}) {
    const  setActiveEdit = useSetRecoilState(activeformEditEntiteState);
    const setActiveNew = useSetRecoilState(activeformNewEntiteState);
    const setForm = useSetRecoilState(markerFormEditState);    
    const itemcurrentCollection = useRecoilValue(collectionsCurState); 
    const typeCollection = useRecoilValue(typeCollectionState);       
    const api_collection = useRecoilValue(apiCollectionState); 
    const user_data = useRecoilValue(userDataState);  
    const setLayerEdit = useSetRecoilState(idLayerEditState);
    const setTypeEdit = useSetRecoilState(typeformEditEntiteState);
    const setModeleLayer = useSetRecoilState(modeleLayerCurState);
    const LocalData = useRecoilValue(localDataState);       
    const setToast = useSetRecoilState(toastState);    
    const setLoading = useSetRecoilState(loadingState);
    const setBoolModif = useSetRecoilState(boolModifState); 
    const collectionsModele = useRecoilValue(collectionsModeleState);
    const [sortConfigModele, setSortConfigModele] = useRecoilState(sortConfigModeleAtom);
    const [searchQueryModele, setSearchQueryModele] = useRecoilState(searchQueryModeleAtom);
    const [currentPageModele, setCurrentPageModele] = useRecoilState(currentPageModeleAtom);

    const openeditEntity = () => {
        setActiveNew(false);
        setActiveEdit(true);
    };
    const creatDataAnnotation = (options,typelay) => {
        const userId = user_data?.user?.id;
        const newDataAnnotation = {
            collection_id: itemcurrentCollection.id,
            css: "null",
            measure: false,
            nb_fichier:0,
            observation: "",
            options: options,
            sogefi_date: new Date().toISOString(),
            sogefi_date_modification: '',
            sogefi_operateur_creation: userId ?? null,
            sogefi_operateur_modification: '',
            tag: false,
            titre: "",
            type: typelay,
        };
        return newDataAnnotation;
    };

    /*
    *lorsque le dessin est effectué
    *mettre ajour les state contenant la ligne dans le tableau 
    */
    const prepareCreate = async(result) => {
        const layer = result.layer.data; 
        setEntiteslist((prev) => [...prev, layer]);
        setOpenStates(prev => ({
            ...prev,
            [result.layer._leaflet_id]: true
        }));
        setLayerEdit(result.layer._leaflet_id);        
    };

    const handleCreateMarker = async() => {
        setTypeEdit('marker');
        const options = {
          icon: L.ExtraMarkers.icon({
            icon: 'fa-circle',
            markerColor: '#252525',
            iconColor: '#FFFFFF',
            shape: 'circle',
            prefix: 'fa',
            svg: true,
          }),
        };
        const newDataAnnotation = creatDataAnnotation(options,"marker");
        const result = await DrawService.setDrawitem(options, newDataAnnotation,'marker', 'marqueur');
        
        const prefix = options.icon.options.prefix || "";
        const icon   = options.icon.options.icon || "";
        const iconClassVal = prefix && icon ? `${prefix} ${icon}` : prefix ? `${prefix}` : "";
        setForm((prev) => ({
            ...prev,
            latitude: result.layer.getLatLng().lat,
            longitude: result.layer.getLatLng().lng,
            markerColor: options.icon.options.markerColor,
            iconColor: options.icon.options.iconColor,
            markerShape: options.icon.options.shape,
            iconClass: iconClassVal, 
            // iconClass: options.icon.options.prefix+' '+options.icon.options.icon, // ou une autre valeur par défaut
            nomEntite: "", 
            observation: "",
        }));      
        setBoolModif(true);

        prepareCreate(result); 
        if(!LocalData){      
            addEntiteToDataBase('marker',result);
        }
       
        openeditEntity();
    };

    
    const handleCreatText = async() => {
        setTypeEdit('textMarker');
        const options = {
            icon:L.divIcon({
                className: 'text-labels',
                html: "Texte",
            }),
        };        
       const newDataAnnotation = creatDataAnnotation(options,"marker");
       const result = await DrawService.setDrawitem(options, newDataAnnotation, 'textMarker', 'texte');
       setForm((prev) => ({
            ...prev,
            latitude: result.layer.getLatLng().lat,
            longitude: result.layer.getLatLng().lng,
            nomEntite: "Texte", 
            observation: "",
            textColor:"#252525",
            textSize: 12,
        }));
        setBoolModif(true);
       
        prepareCreate(result);
        if(!LocalData){      
            addEntiteToDataBase('textMarker',result);
        }
        
        openeditEntity();
    };
    
    const handleCreatDraw = async(type) => {        
        setTypeEdit(type);
        const options = {
            editing: {
                className: undefined,
            },
            color: "#92bbf4",
        };
        const newDataAnnotation = creatDataAnnotation(options,type);
        const result = await DrawService.setDrawitem(options, newDataAnnotation, type, '');
       
        let radius = 0;
        if (result.layer.getRadius) { 
            radius = result.layer.getRadius();
        }     
        setForm((prev) => ({
            ...prev,
            nomEntite: "", 
            observation: "",
            lineColor:"#92bbf4",
            lineOpacity:0.5,
            lineEpaisseur:4,
            polycontourColor:"#92bbf4",
            polycontourOpacity:0.5,
            polycontourEpaisseur:4,
            polyColor:"#92bbf4",
            polyOpacity:0.2,
            radius:radius,
        }));           
        setBoolModif(true);   
        
        prepareCreate(result);
        
        if(!LocalData){      
            addEntiteToDataBase(type,result);
        }
        
       openeditEntity();
    };

    const addEntiteToDataBase = (type,result) => {
        setLoading(true);
        const layer = result.layer;
        const css = type == "textMarker" ? JSON.stringify({"font-size":"14px", "color":'#252525'}) :  null;
        const titre = type == "textMarker" ? 'Texte' :  "";
        const collectionid = layer.data.collection_id;
        
        const userId = user_data.user.id;
        const urlApi = api_collection+ user_data.account.port+ '/';    

        var entite = {
            "titre": titre,
            "measure": false,
            "observation": "",
            "options":JSON.stringify(layer.data.options),
            css: css,
            "geom":JSON.stringify(layer.toGeoJSON().geometry),
            "type": type,
            "tag": false
        };
           
        CollectionService.addEntite(urlApi,userId,entite,collectionid).then((response) => { 
            if(response.id){
                setToast({ message: response.message , type: 'success' });
                setEntiteslist((preventite) =>
                    preventite.map((item) =>
                      item.id === result.layer._leaflet_id ? { ...item, idnewbd: response.id } : item
                    )
                );                
            } else {
                setToast({ message: response.message , type: 'error' });
            }       
            setLoading(false);
        });
       
    };

    const typeFR = {
        textMarker: { img: <i className={`fa-solid fa-text ${genStyles.fontSize20}`}></i> },
        marker: { img: <i className={`fa-solid fa-location-dot ${genStyles.fontSize20}`}></i> },
        circle: { img: <i className={`fa-solid fa-circle ${genStyles.fontSize20}`}></i> },
        polyline: { img: <i className={`fa-kit fa-draw-polyline-icon ${genStyles.fontSize20}`}></i> },
        polygon: { img: <i className={`fa-solid fa-vector-polygon ${genStyles.fontSize20}`}></i> },
        rectangle: { img: <i className={`fa-solid fa-vector-square ${genStyles.fontSize20}`}></i> },
    };
    
    const columnsModele = [       
        { key: 'libelle', label: 'Nom', width:'70px', align: 'center', selectable: true },
        { 
            key: 'type', 
            label: "Type",
            align: 'center', 
            selectable: true,
            width:'70px',
            render: (_, row) => {
                const typeInfo = typeFR[row.type];
                let parsedOptions = {};
                try {
                  parsedOptions = row?.options
                    ? typeof row.options === "string"
                      ? JSON.parse(row.options)
                      : row.options
                    : {};
                } catch {
                  parsedOptions = {};
                }
                const color = parsedOptions?.color || parsedOptions?.icon?.options?.markerColor || '#000';
            
                return (
                <div className="cursor-pointer center-align">
                    <span style={{ color }}>
                    {typeInfo?.img}
                    </span>
                </div>
                );
            }
        },
        { key: 'description', label: 'Description', selectable: true }
    ];

    
    const selectAllDataRow = async(row) => {     
        const userId = user_data?.user?.id;   
        const urlApi = api_collection+ user_data.account.port+ '/';    
        const options =  JSON.parse(row.options);        
        setLoading(true);
        const newDataAnnotation = {
            collection_id: itemcurrentCollection.id,
            css: "null",
            measure: false,
            nb_fichier:0,
            observation: row.description,
            options: options,
            sogefi_date: new Date().toISOString(),
            sogefi_date_modification: '',
            sogefi_operateur_creation: userId ?? null,
            sogefi_operateur_modification: '',
            tag: false,
            titre: row.libelle,
            type: row.type,
        };
         
        const layer = await DrawService.createEntityModele(row,newDataAnnotation);
       
        if(layer){           
            setForm((prev) => ({
                ...prev,
                nomEntite: row.libelle,
                observation: row.description,
                lineColor:options.color,
                lineOpacity:options.opacity,
                lineEpaisseur:options.weight,
                polycontourColor:options.color,
                polycontourOpacity:options.opacity,
                polycontourEpaisseur:options.weight,
                polyColor:options.fillColor || options.color,
                polyOpacity:options.fillOpacity,
                radius:"",
            }));     
            
            const entite = {
                "titre": row.libelle,
                "measure": false,
                "observation": row.description,
                "options":JSON.stringify(layer.data.options),
                "css": null,
                "geom":JSON.stringify(layer.toGeoJSON().geometry),
                "type": row.type,
                "tag": false
            };                   
           
            CollectionService.addEntite(urlApi,userId,entite,itemcurrentCollection.id).then((response) => { 
                if(response.id){
                    afterCreateEntiteModele(response.id,layer.id);
                    setModeleLayer(
                        { ...layer.data, idnewbd: response.id } 
                    );
                    setOpenStates(prev => ({
                        ...prev,
                        [response.id]: true
                    }));    
                    const layerdata = {
                        ...layer.data,
                        id: response.id,
                        geojson: { ...layer.data.geojson, properties: { ...layer.data.geojson.properties, id: response.id } }
                    };
                    setEntiteslist((prev) => [...prev, layerdata]);

                      
                } else {
                    setToast({ message: response.message , type: 'error' });
                }       
                setLoading(false);
            });
        }
        
        
    };

    const afterCreateEntiteModele = async (entite_id, layer_id) => {
        const userId = user_data?.user?.id;
        const urlApi = api_collection + user_data.account.port + '/';
      
        DrawService.deleteLayerEntityModele(layer_id);
      
        // Récupération de l'entité
        const response = await CollectionService.getEntiteFromCollection(
          urlApi,
          userId,
          entite_id,
          itemcurrentCollection.id
        );
      
        DrawService.typeCollectionCur = typeCollection;
        DrawService.infoCollectionCur = itemcurrentCollection;
      
        setTypeEdit(response.type);
        setDataFormulaireMarker(response);
        setLayerEdit(response.id);
      
        // Dessiner layer + activer l'édition
        const layeredit = await ShowService.addEntitesToMap(response.geojson, 'edit');
      
        ShowService.updateFormEdit(
          layeredit[0],
          setForm,
          setEntiteslist,
          setBoolModif
        );
      
        setToast({ message: response.message , type: 'success' });  
        setActiveNew(false);
        setActiveEdit(true);           
        setLoading(false);
    };
      
    
    const setDataFormulaireMarker = (row) => {
        let formData = {};
        L.geoJson(row.geojson, {
        onEachFeature: (feature, layer) => {
            const isPoint = typeof layer.getLatLng === 'function';
            formData = {
            nomEntite: row.titre,
            observation: row.observation,
            latitude:  isPoint ? layer.getLatLng().lat : null,
            longitude: isPoint ? layer.getLatLng().lng : null,
            markerShape: feature.properties?.options?.icon?.options?.shape ?? '',
            markerColor: feature.properties?.options?.icon?.options?.markerColor ?? '',
            iconClass: feature.properties?.options?.icon?.options?.prefix+' '+feature.properties?.options?.icon?.options?.icon,
            iconColor: feature.properties?.options?.icon?.options?.iconColor,
            textColor:feature.properties?.css?.color ?? '#252525',
            textSize: (() => {
                const val = parseInt(feature.properties?.css?.["font-size"], 10);
                return Number.isNaN(val) ? '' : val;
            })(),
            lineColor: feature.properties?.options?.color ?? '#92bbf4',
            lineOpacity: feature.properties?.options?.opacity ?? '0.5',
            lineEpaisseur: feature.properties?.options?.weight ?? '4',
            polycontourColor: feature.properties?.options?.color ?? '#92bbf4',
            polycontourOpacity: feature.properties?.options?.opacity ?? '0.5',
            polycontourEpaisseur: feature.properties?.options?.weight ?? '4',
            polyColor: feature.properties?.options?.fillColor ?? feature.properties?.options?.color,
            polyOpacity: feature.properties?.options?.fillOpacity ?? '0.2',
            radius:feature.properties?.options?.radius ?? '0',
            tag : row.tag ?? false,
            measure : row.measure ?? false, 
            afficher_centroide:row.afficher_centroide ?? false, 
            };
        }
        });
        setForm((prev) => ({
        ...prev,
        ...formData
        }));
    };

    return (
        <div>
            <div className="center-align">
                <p className="font_size_16">Quel type de contenu souhaitez-vous ajouter ?</p>
            </div>
            <div className={genStyles.entityTypeGrid}>
                <button type="button" className={genStyles.entityTypeBtn} onClick={handleCreateMarker}>
                    <i className="fa-solid fa-location-dot" aria-hidden="true"></i>
                    <span>Marqueur</span>
                </button>
                <button type="button" className={genStyles.entityTypeBtn} onClick={handleCreatText}>
                    <i className="fa-solid fa-text" aria-hidden="true"></i>
                    <span>Annotation</span>
                </button>
                <button type="button" className={genStyles.entityTypeBtn} onClick={() => handleCreatDraw('polyline')}>
                    <i className="fa-kit fa-draw-polyline-icon" aria-hidden="true"></i>
                    <span>Ligne</span>
                </button>
                <button type="button" className={genStyles.entityTypeBtn} onClick={() => handleCreatDraw('circle')}>
                    <i className="fa-solid fa-circle" aria-hidden="true"></i>
                    <span>Cercle</span>
                </button>
                <button type="button" className={genStyles.entityTypeBtn} onClick={() => handleCreatDraw('rectangle')}>
                    <i className="fa-solid fa-vector-square" aria-hidden="true"></i>
                    <span>Rectangle</span>
                </button>
                <button type="button" className={genStyles.entityTypeBtn} onClick={() => handleCreatDraw('polygon')}>
                    <i className="fa-solid fa-vector-polygon" aria-hidden="true"></i>
                    <span>Polygone</span>
                </button>
            </div>

            {!LocalData && (
                <>
                    <div className="col s12">
                        <div className={genStyles.sectionHeaderBar}>
                            <span className={genStyles.sectionHeaderTitle}>
                                <i className="fa-solid fa-shapes" aria-hidden="true"></i>
                                MODÈLES
                            </span>
                        </div>
                    </div>
                    <div className="col s12 center-align">
                    {modeleCollection ? (
                        <ResultForm
                            data={collectionsModele}
                            columns={columnsModele}
                            onSelectRow={selectAllDataRow}
                            pageSize={10}
                            tableHeight="auto"
                            textpaginate="modèles"
                            textnone="Aucun modèle"
                            texteSearch="Rechercher"
                            sortConfig={sortConfigModele}
                            setSortConfig={setSortConfigModele}
                            searchQuery={searchQueryModele}
                            setSearchQuery={setSearchQueryModele}
                            currentPage={currentPageModele}
                            setCurrentPage={setCurrentPageModele}
                        />
                    ) : (
                        <div className={genStyles.emptyStateCtn}>
                            <div className={genStyles.emptyStateIcon}>
                                <i className="fa-solid fa-lock"></i>
                            </div>
                            <p className={genStyles.emptyStateText}>
                                Module optionnel.<br/>
                                Contactez-nous pour plus d'informations.
                            </p>
                            <a
                                href="https://www.sogefi-sig.com/module-collections-ayez-la-main-sur-votre-carte/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className={`${genStyles.modalBtn} ${genStyles.modalBtnPrimary}`}
                            >
                                <i className={`fa-solid fa-circle-info ${genStyles.icomargin}`}></i>
                                En savoir plus
                            </a>
                        </div>
                    )}
                    </div>
                </>
            )}
        </div>  
    );
}
